import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import useFeedback from "../../utils/use_feedback";
import {useCommunities} from "../../api/communities";
import Community from "../community";
import {useProfile} from "../../api/user";

const List = styled.div``;

const ModeratingSheet = styled(({className, username, onClose}) => {

    const {error, feedbackCh} = useFeedback();
    const profile = useProfile(feedbackCh, username);

    const communities = useCommunities(feedbackCh, profile?.moderates || []);

    return (
        <div className={className}>

            <List>

                {communities?.map((community) =>
                    community && community.visibility !== 'unlisted' && (
                        <Community
                            condensed
                            key={community.name}
                            community={community}
                        />
                    )
                )}

            </List>

        </div>
    );
})`
`;

export default ModeratingSheet;
